var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalGroupVisible,
          expression: "isModalGroupVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-slideout modal-lg" },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "width-100" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-9 pl-3" }, [
                      _c(
                        "div",
                        { staticClass: "h3 d-inline mr-2 text-uppercase" },
                        [_vm._v("Create New Group")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.isSuccessPanel
                    ? _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.saveGroup($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c("label", { staticClass: "form-label" }, [
                                _vm._v("Group Name")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.group_name,
                                    expression: "group_name"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      rules: {
                                        required: true,
                                        regex: _vm.nameRegex()
                                      }
                                    },
                                    expression:
                                      "{ rules: { required: true, regex: nameRegex() } }"
                                  }
                                ],
                                ref: "group_name",
                                staticClass:
                                  "col-12 col-sm-12 input-height-35 form-control",
                                attrs: {
                                  type: "text",
                                  id: "group_name",
                                  name: "group_name",
                                  placeholder: "Enter Group Name",
                                  maxlength: "250",
                                  autocomplete: "off"
                                },
                                domProps: { value: _vm.group_name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.group_name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("group_name", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Group name is required")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("group_name", "regex")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [
                                      _vm._v(
                                        "Group name should only contain - and _"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.groupExists
                                ? _c("div", { staticClass: "text-red" }, [
                                    _vm._v(_vm._s(_vm.groupExists))
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row submit_row justify-content-md-center"
                            },
                            [
                              _c("div", { staticClass: "col-6" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-blue saveBtn text-center",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v("Create New Group")]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _c("div", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "successPanel" }, [
                              _c("div", { staticClass: "col-9" }, [
                                _c("p", { staticClass: "success-msg" }, [
                                  _vm._v("Success!")
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "success-note" }, [
                                  _c("i", {
                                    staticClass: "fa fa-check-circle-o"
                                  }),
                                  _vm._v(
                                    "\n                                                New Group Created\n                                            "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-3 mt-3" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/enterprise/Required_Rocket_Image_106x101.png"),
                                    width: "70"
                                  }
                                })
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "row gotoBtn justify-content-md-center"
                          },
                          [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-blue saveBtn text-center",
                                  attrs: { type: "button" },
                                  on: { click: _vm.goToGroup }
                                },
                                [_vm._v("Go to Group")]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mt-4 justify-content-md-center" },
                          [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-blue closeBtn text-center",
                                  attrs: { type: "button" },
                                  on: { click: _vm.close }
                                },
                                [_vm._v("Close Window")]
                              )
                            ])
                          ]
                        )
                      ])
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("ExistingGroup", {
        ref: "existing_group_panel",
        attrs: {
          isModalExistingGroupVisible: _vm.isModalExistingGroupVisible,
          accountId: _vm.accountId
        },
        on: { close: _vm.closeExistingGroupSidebar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac0be63e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac0be63e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/add_new_group.vue
// module id = null
// module chunks = 